"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTouch = function () {
    return 'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0;
};
exports.addNonTouchClass = function () {
    var isTouch1 = process.env.NODE_ENV === 'test' ? exports.isTouch : exports.isTouch; // eslint-disable-line no-undef
    if (!isTouch1()) {
        // browser doesn't support touch
        document.body.classList.add('non-touch');
    }
};
exports.listenUsingMouseClass = function () {
    document.body.addEventListener('mousedown', function () {
        document.body.classList.add('using-mouse');
    });
    document.body.addEventListener('keydown', function (e) {
        var isTab = e.key === 'Tab' || e.keyCode === 9;
        if (isTab) {
            document.body.classList.remove('using-mouse');
        }
    });
};
exports.getIsUsingMouse = function () {
    return !document.body.classList.contains('using-mouse');
};
